import React from 'react';
// Make sure you have this import line:
import { createRoot } from 'react-dom/client';
import './index.css'; // Or your main CSS file
import App from './App'; // Your main App component
import reportWebVitals from './reportWebVitals';

// Find the root DOM element (usually a div with id='root' in public/index.html)
const container = document.getElementById('root');

// Create a root.
const root = createRoot(container); // This is where createRoot is used (likely around line 8)

// Initial render: Render your app component to the root.
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();